export default __webpack_public_path__ + "static/media/gallery1.aad85bf5.JPG";